import {Component, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "@shared/services/web/toastr.service";
import {Router} from "@angular/router";
import {AuthenticationService} from "@app/auth/authentication.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {IMeta, MetaService} from "@shared/services/web/meta.service";
import {finalize} from "rxjs";
import {untilDestroyed} from "@core/until-destroyed";
import { DatalayerService } from '@app/@shared/services/web/datalayer.service';
import { isPlatformBrowser } from "@angular/common";
import { Inject, PLATFORM_ID } from "@angular/core";

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent {
  @ViewChild('exito', { static: false }) contenidoDelModal: any;

  recoverForm!: FormGroup;
  isLoading = false;
  constructor(
    private toastrService: ToastrService,
    private router: Router,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private modalService: NgbModal,
    public translateService: TranslateService,
    private metaService: MetaService,
    private datalayerService: DatalayerService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {

    this.changeMeta();
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.changeMeta();
    });
    this.createForm();
  }

  changeMeta() {
    const meta: IMeta = {
      language: this.translateService.currentLang,
      title: 'recover_pass',
      description: 'recover_pass_desc',
    };
    this.metaService.changeMeta(meta);
  }

  openModal() {
    this.modalService.open(this.contenidoDelModal, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }

  seguirInvirtiendo() {
    this.modalService.dismissAll();
    this.router.navigate(
      ['/' + this.translateService.getCurrentLang(), 'invertir'],
      { replaceUrl: true }
    );
  }

  createForm() {
    this.recoverForm = this.formBuilder.group({
      email: ['', Validators.required],
    });
  }
  ngOnDestroy() {}

  recoverPassword() {
    this.isLoading = true;
    this.authenticationService
      .recoverPassword(this.recoverForm.value)
      .pipe(
        finalize(() => {
          this.recoverForm.markAsPristine();
          this.isLoading = false;
        }),
        untilDestroyed(this)
      )
      .subscribe(
        () => {
          this.openModal();

          this.datalayerService.push('form_submitted', {
            form_id: 'form_recover_password',
            form_name: 'Formulario Recuperar Contraseña',
            form_location: 'page',
            page_language: this.translateService.getCurrentLang(),
            page_location: isPlatformBrowser(this.platformId) ? window.location.href : '',
            page_path: isPlatformBrowser(this.platformId) ? window.location.pathname : '',
          });
        },
        (error: any) => {
          this.toastrService.error(error.error.message, 'Ha ocurrido un error');
        }
      );
  }
}
